import { IBaseModel, BaseModel } from '../base.model'
import {BMIBContractorViewModel} from "./bm-ib-contractor.viewmodel";

export interface IBMIBViewModel extends IBaseModel {
  fk_character_problem: number,
  fk_bm_meeting: number,
  fk_entity_creator: number,
  bm_ib_contractor:BMIBContractorViewModel[],
  //name?: string
  character_problem: {
    name: string,
    picto: string
  },
  color: string,
}
export class BmIBViewModel extends BaseModel implements IBMIBViewModel {
  fk_character_problem: number
  fk_bm_meeting: number
  fk_entity_creator: number
  bm_ib_contractor:BMIBContractorViewModel[]
  //name?: string
  character_problem: {
    name: string
    picto: string
  }
  color: string
}



// WEBPACK FOOTER //
// ./src/models/bm/bm-ib.viewmodel.ts